import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Grid } from '@mui/material'
import { CaffeineOptions, CaffeinePressable } from '../../components'
import { useTranslation } from "react-i18next"

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const CaffeinePressableListCount = ({
  caffeineProducts,
  selectedOptions,
  onSelectOption,
}) => {
  const { t } = useTranslation('common')
  const caffeineProductNames = {
    'No Caffeine': t('caffeine.none'),
    Coffee: 'Café',
    'Energy Drink': t('caffeine.energy_drink'),
  }
  const [normalizedCaffeineProducts, setNormalizedCaffeineProducts] =
    useState(caffeineProducts)
  const [disableOptions, setDisableOptions] = useState(false)

  useEffect(() => {
    if (selectedOptions.length === 0) setDisableOptions(false)
  }, [selectedOptions])

  const handleSelectOption = option => {
    if (option.isNoCaffeine) {
      if (selectedOptions.find(item => item.id === option.id)) {
        onSelectOption([])
        setDisableOptions(false)

        return
      }

      onSelectOption([option])
      setDisableOptions(true)

      return
    }

    if (disableOptions) return

    const optionIncluded = selectedOptions.find(
      product => product.id === option.id,
    )

    if (optionIncluded) {
      const optionIndex = selectedOptions.findIndex(
        item => item.id === option.id,
      )

      const copySelectedOptions = selectedOptions

      copySelectedOptions[optionIndex] = {
        ...option,
        count: copySelectedOptions[optionIndex].count + 1,
      }

      onSelectOption([...copySelectedOptions])
      return
    }

    onSelectOption([...selectedOptions, { ...option, count: 1 }])
  }

  const calculateTimesPressed = ({ option }) => {
    if (selectedOptions.find(item => item.id === option.id)) {
      const optionItem = selectedOptions.find(item => item.id === option.id)
      return optionItem.count
    }

    return null
  }

  const isSelected = ({ optionId }) => {
    if (selectedOptions.find(item => item.id === optionId)) return true

    return false
  }

  useEffect(() => {
    if (normalizedCaffeineProducts) {
      const newCaffeineProducts = normalizedCaffeineProducts.map(product => {
        return {
          ...product,
          name: caffeineProductNames[product.name] || product.name,
        }
      })

      setNormalizedCaffeineProducts(newCaffeineProducts)
    }
  }, [])

  return (
    <Container style={{ maxWidth: 640 }}>
      <Grid
        container
        spacing={3}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          maxWidth: 900,
        }}
      >
        {normalizedCaffeineProducts.map(item => {
          return (
            <Grid
              item
              key={item.id}
            >
              <CaffeinePressable
                timesPressed={calculateTimesPressed({ option: item })}
                onClick={() => handleSelectOption(item)}
                imgOption={<CaffeineOptions tag={item.imgTag} />}
                nameOption={item.name}
                caffeineQty={item.isNoCaffeine ? null : item.description}
                isSelected={isSelected({ optionId: item.id })}
                disableOptions={disableOptions}
              />
            </Grid>
          )
        })}
      </Grid>
    </Container>
  )
}

export default CaffeinePressableListCount
